module.exports = __webpack_public_path__ + "img/image_5.bf0101fc.png";